const castToNumber = numberOrUndefined => {
  return numberOrUndefined === undefined ? 0 : numberOrUndefined * 1
}

const getPrice = obj => {
  if (obj.discountedUnitPriceSet) {
    return castToNumber(obj?.discountedUnitPriceSet?.shopMoney?.amount)
  } else if (obj.variant) {
    return obj.variant.price
  }
  return 0
}

const generateDuplicateOrder = (order, priceCurrency) => {
  const totalDiscount = order.currentTotalDiscountsSet?.shopMoney?.amount
  const totalTaxes = order.currentTotalTaxSet?.shopMoney?.amount

  let discount = false
  if (totalDiscount > 0) {
    discount = {
      number: totalDiscount,
      isPercent: false,
    }
  }

  const existingOrderDefaults = {
    orderItems: [],
    hasTaxes: false,
    shipping: { type: 'free' },
    discount,
    notes: order.note,
    tags: order.tags ? order.tags.join(',') : '',
  }

  const taxes = castToNumber(totalTaxes)
  if (taxes > 0) existingOrderDefaults.hasTaxes = true

  const lineItems = order.lineItems?.edges || []
  lineItems.forEach(obj => {
    const item = obj.node
    const variant = item.variant
    if (!variant) {
      const quantity = item.currentQuantity || 1
      const price = getPrice(item)
      const newItem = {
        ...item,
        custom: true,
        displayName: item.name,
        title: item.name,
        product: {
          name: item.name,
        },
        customPrice: price,
        price: {
          price,
          currency: 'USD',
        },
        quantity,
        total: price * quantity,
      }
      existingOrderDefaults.orderItems.push(newItem)
      return newItem
    }
    const price = getPrice(item)
    const quantity = item.currentQuantity || 1
    const total = price * quantity
    const newItem = {
      ...item,
      variantId: variant?.id,
      product: {
        name: variant?.displayName,
        stock: variant?.inventoryQuantity,
        sku: variant?.sku,
      },
      price: {
        price: price * 100, // all prices we get are with decimals
        currency: priceCurrency,
      },
      quantity,
      total: total * 100,
    }
    existingOrderDefaults.orderItems.push(newItem)
    return newItem
  })

  return existingOrderDefaults
}

export default generateDuplicateOrder
